/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-05T13:37:50+02:00
*/

// based on: https://github.com/callemall/material-ui/blob/master/src/internal/RenderToLayer.js

import {Component} from 'react';
import PropTypes from 'prop-types';
import {unstable_renderSubtreeIntoContainer, unmountComponentAtNode} from 'react-dom'; // eslint-disable-line camelcase

import Dom from './../utilities/dom';

// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
class RenderToLayer extends Component {
  componentDidMount() {
    this.renderLayer();
  }

  componentDidUpdate() {
    this.renderLayer();
  }

  componentWillUnmount() {
    this.unrenderLayer();
  }

    onClickAway = (event) => {
      if (event.defaultPrevented) {
        return;
      }

      if (!this.props.componentClickAway) {
        return;
      }

      if (!this.props.open) {
        return;
      }

      const el = this.layer;
      if (event.target !== el && event.target === window ||
            (document.documentElement.contains(event.target) && !Dom.isDescendant(el, event.target))) {
        this.props.componentClickAway(event);
      }
    };

    getLayer() {
      return this.layer;
    }

    unrenderLayer() {
      const {
        targetRenderNode,
      } = this.props;

      if (!this.layer) {
        return;
      }

      if (this.props.useLayerForClickAway) {
        this.layer.style.position = 'relative';
        this.layer.removeEventListener('touchstart', this.onClickAway);
        this.layer.removeEventListener('click', this.onClickAway);
      } else {
        window.removeEventListener('touchstart', this.onClickAway);
        window.removeEventListener('click', this.onClickAway);
      }

      unmountComponentAtNode(this.layer);
      if ( targetRenderNode() != null ) {
        targetRenderNode().removeChild(this.layer);
      } else {
        document.body.removeChild(this.layer);
      }
      this.layer = null;
    }

    /**
    * By calling this method in componentDidMount() and
    * componentDidUpdate(), you're effectively creating a "wormhole" that
    * funnels React's hierarchical updates through to a DOM node on an
    * entirely different part of the page.
    */
    renderLayer() {
      const {
        open,
        render,
        className,
        targetRenderNode,
      } = this.props;

      if (open) {
        if (!this.layer) {
          this.layer = document.createElement('div');
          if (className) this.layer.className = className;
          if ( targetRenderNode() != null ) {
            targetRenderNode().appendChild(this.layer);
          } else {
            document.body.appendChild(this.layer);
          }

          if (this.props.useLayerForClickAway) {
            this.layer.addEventListener('touchstart', this.onClickAway);
            this.layer.addEventListener('click', this.onClickAway);
            this.layer.style.position = 'fixed';
            this.layer.style.top = 0;
            this.layer.style.bottom = 0;
            this.layer.style.left = 0;
            this.layer.style.right = 0;
            this.layer.style.zIndex = 1000000;
          } else {
            setTimeout(() => {
              window.addEventListener('touchstart', this.onClickAway);
              window.addEventListener('click', this.onClickAway);
            }, 0);
          }
        }

        const layerElement = render();
        this.layerElement = unstable_renderSubtreeIntoContainer(this, layerElement, this.layer);
      } else {
        this.unrenderLayer();
      }
    }

    render() {
      return null;
    }
}
RenderToLayer.propTypes = {
  componentClickAway: PropTypes.func,
  open: PropTypes.bool.isRequired,
  render: PropTypes.func.isRequired,
  useLayerForClickAway: PropTypes.bool,
  /**
     * class name for the layer - it may be needed to overwrite styles when
     * elements are rendered on this external layer
     */
  className: PropTypes.string,
  /**
     * async function to return DOM Node for
     * overlay render
     * could return null to signal document.body should be used
     */
  targetRenderNode: PropTypes.func,
};
RenderToLayer.defaultProps = {
  useLayerForClickAway: true,
  targetRenderNode: function() {
    return (typeof window != 'undefined' && window.OA_OVERLAY_TARGET) || null;
  },
};
export default RenderToLayer;

